import { ClockIcon } from '@heroicons/react/24/outline'
import { useTranslation } from 'libs/i18n'

import { CtaLink } from 'shared/components'
import { WithClassName } from 'shared/types/general.types'

type HistoryButtonProps = WithClassName<{
	to: string
}>

export const HistoryButton = ({ to, className }: HistoryButtonProps) => {
	const { t } = useTranslation()

	return (
		<CtaLink
			to={to}
			text={t('History')}
			icon={<ClockIcon />}
			variant="outline"
			compact
			className={className}
		/>
	)
}
